// extracted by mini-css-extract-plugin
export default {"title":"GameSummary_title__zr4pB","container":"GameSummary_container__mNrIK","score":"GameSummary_score__76t8m","gradient":"GameSummary_gradient__2gZhX"};